import type { FirebaseApp } from 'firebase/app';
import { connectFunctionsEmulator, getFunctions, httpsCallable, type Functions } from 'firebase/functions';

import type { EmulatorEndpoint } from '@taki/runtime-config';

/** La Function qui dit si la base d'une fiche a son chatter allume (`functions/src/chatter/gardeChatter.ts`). */
export const CALLABLE_ETAT_DU_CHATTER = 'etatDuChatter';
export const CHATTER_FUNCTIONS_REGION = 'europe-west1';

/** Lit l'etat du chatter d'une fiche : `true` = allume. */
export type LireEtatDuChatter = (ancre: { family: string; recordId: string }) => Promise<boolean>;

const emulatorBoundFunctions = new WeakSet<Functions>();

/**
 * L'ETAT DU CHATTER, LU AU SERVEUR (verification independante du 06/10,
 * ecart C) : la meme lecture que la garde `gardeChatterDeFiche`, pour que
 * l'ecran et le serveur ne divergent jamais. Le client ne connait pas les
 * declarations de toutes les apps ; la Function, si.
 */
export function createLecteurEtatDuChatter(app: FirebaseApp, emulator?: EmulatorEndpoint | undefined): LireEtatDuChatter {
  let appeler: ReturnType<typeof httpsCallable<unknown, { actif?: unknown }>> | null = null;
  return async (ancre) => {
    if (appeler === null) {
      const functions = getFunctions(app, CHATTER_FUNCTIONS_REGION);
      if (emulator && !emulatorBoundFunctions.has(functions)) {
        connectFunctionsEmulator(functions, emulator.host, emulator.port);
        emulatorBoundFunctions.add(functions);
      }
      appeler = httpsCallable<unknown, { actif?: unknown }>(functions, CALLABLE_ETAT_DU_CHATTER);
    }
    const reponse = await appeler({ family: ancre.family, recordId: ancre.recordId });
    return reponse.data?.actif !== false;
  };
}
